import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { observable } from 'aurelia-typed-observable-plugin';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssTextareaPage extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////

    ////****************** Example 2 ********************************************////
    protected ex2Text: string = '';
    @observable protected ex2MaxLength: number | null = 10;

    protected ex2MaxLengthChanged(): void {
        if(this.ex2MaxLength === 0) {
            this.ex2Text = '';
        }
        if(!this.ex2MaxLength || this.ex2Text.length === 0) return;
        if(this.ex2Text.length > this.ex2MaxLength) {
            this.ex2Text = this.ex2Text.slice(0, this.ex2MaxLength);
        }
    }

    ////****************** Example 3 ********************************************////

    ////****************** Example 4 ********************************************////
    protected ex4Label: string | null = 'Select a Value';
    protected ex4Text: string = '';
    @observable protected ex4MaxLength: number | null = 10;

    protected ex4MaxLengthChanged(): void {
        if(this.ex4MaxLength === 0) {
            this.ex4Text = '';
        }
        if(!this.ex4MaxLength || this.ex4Text.length === 0) return;
        if(this.ex4Text.length > this.ex4MaxLength) {
            this.ex4Text = this.ex4Text.slice(0, this.ex4MaxLength);
        }
    }

}
